import { EnvironmentBanner, ImpersonationBanner } from '@korint/folio';
import { Outlet } from 'react-router-dom';

export function DefaultContainerLayout() {
  return (
    <div className="relative container mx-auto px-4 pt-4 pb-20">
      <ImpersonationBanner />
      <EnvironmentBanner />
      <Outlet />
    </div>
  );
}
